export default "__VITE_ASSET__BBVgAZIQ__"